import React from "react";
import { useForm } from "react-hook-form";
import { AddBrandPostApi } from "../../../Api/SupplierServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import MenuTitle from "../../MenuTitlle/MenuTitle";
import Style from './AddBrandSupermarket.module.css'
const AddBrandSupermarket = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();

    const onSubmit=(data,e)=>{
        let info={
            brand_persian:data.persianbrand,
            brand_english:data.englishbrand,
            file:"",
        }
        AddBrandPostApi(info,res=>{
            if(res.status===1){
                succToast(res.message)
                e.target.reset();
            }
            else{
                errorToast("خطایی رخ داده است")
                e.target.reset();
            }
        })
    }    
    return (
        <div className={Style.componentHolder}>
            <MenuTitle title={"افزودن برند"} />
            <div className={Style.picHolder}>
                <img src={"./Assets/Images/brand/brand.svg"} alt={""}/>
            </div>
            <form
                onSubmit={handleSubmit(onSubmit)}
                className={Style.FormAddProduct}
            >
                <input
                    {...register("persianbrand",{required:true})}
                    className={errors.persianbrand?Style.errorInput: Style.fileInputPart2}
                    placeholder={"نام برند به فارسی "}
                />
                <input
                    {...register("englishbrand",{required:true})}
                    className={errors.englishbrand?Style.errorInput: Style.fileInputPart2}
                    placeholder={"نام برند به انگلیسی"}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button className={Style.btnStyle} type={"submit"}>
                        ثبت
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddBrandSupermarket;
